import axios from 'axios';

export default function (context, val) {
  let id = val.id;
  let callback = val.callback ? val.callback : () => {
  };
  let regular = context.state.list.filter(i => {
    return i.id === id;
  })[0];
  if (regular) {
    return regular;
  }
  context.commit('set_item', {id});

  axios.all([
    axios({
      method: 'get',
      url: '/tourclient/payment/regular/' + id + '?_=XXX' + new Date().getTime(),
      // requestId: 'payment/regular/' + id,
    }),
    axios({
      method: 'get',
      url: '/tourclient/payment/payInfo/' + id + '?_=XXX' + new Date().getTime(),
      // requestId: 'payment/payInfo/' + id,
    })
  ]).then(axios.spread(function (r, s) {
    let data = r.data.Item;
    let dataSum = s.data;
    if (data) {
      let form = context.rootState.finances.pay.form;
      if (r.data.ResultQueryInfo.HasError) {
        context.rootState.finances.pay.system.none = true;
      }
      context.commit('set_data', {
        id: id,
        label: data.Name,
        paymentOperation: data.PaymentOperationID,
        contragentType: data.ContragentType,
        contragent: data.ContragentID,
        contragentName: data.ContragentName,
        legal: data.PartnerLegalEntityId ? data.PartnerLegalEntityId : '',
        currency: data.CurrencyId,
        sum: dataSum.PaymentSum,
        data
      });
      context.commit('set_form', {
        id: id,
        Name: data.Name,
        NameLat: data.NameLat,
        PaymentOperationID: data.PaymentOperationID,
        RateArticleId: data.RateArticleId,
        CategoryId: context.rootGetters['dictionary/paymentType/getById'](data.PaymentTypeId).CategoryId,
        PaymentTypeId: data.PaymentTypeId,
        CashId: data.CashId,
        PaymentAccountId: data.PaymentAccountId,
        AccountNumber: data.AccountNumber,
        ContragentType: data.ContragentType,
        ContragentID: data.ContragentID,
        ContragentName: data.ContragentName,
        PartnerLegalEntityId: data.PartnerLegalEntityId ? data.PartnerLegalEntityId : 0,
        PartnerLegalName: data.PartnerLegalName,
        Sum: data.Sum,
        CurrencyId: data.CurrencyId,
        RegularPaymentTypeId: data.RegularPaymentTypeId,
        PaymentFor: data.PaymentFor,
        PaymentDate: dataSum.PaymentDate.Serialized,
        Comment: data.Comment,
        NotificationsEndDate: data.NotificationsEndDate ? data.NotificationsEndDate.Serialized : '',
      });
      let date = new Date();
      switch (data.RegularPaymentTypeId) {
        case 0:
          context.commit('set_form', {
            id: id,
            dayMonth: +data.PaymentDay,
            dayYear: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
            dayOne: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
          });
          break;
        case 1:
          context.commit('set_form', {
            id: id,
            dayWeek: +data.PaymentDay,
            dayYear: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
            dayOne: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
          });
          break;
        case 3:
        case 4:
          context.commit('set_form', {id: id, dayYear: data.PaymentDate.Serialized});
          context.commit('set_form', {id: id, dayOne: data.PaymentDate.Serialized});
          break;
      }

      if (data.PaymentDetails && data.PaymentDetails.length) {
        context.commit('finances/pay/set_form', {
          ContragentType: data.ContragentType,
          ContragentID: data.ContragentID,
          PartnerLegalEntityId: data.PartnerLegalEntityId,
          CurrencyId: data.CurrencyId,
        }, {root: true});
        let load = 0;
        let agreements = [];
        data.PaymentDetails.forEach(i => {
          load++;
          agreements.push(i.Code);
          context.dispatch('finances/pay/agreements/add', {
            id: i.Code,
            callback: agreement => {
              load--;
              agreement.ag.course = i.Course && i.Course !== 1 ? i.Course : 1;
              if(!i.Course&&data.CurrencyId!==agreement.currency){
                window.app.$notify.warning({
                  title: 'Введите курс',
                  message: 'Детализация путевки: ' + i.Code,
                });
              }
              if (form.ContragentType === 3) {
                if (i.OrderPrices) {
                  i.OrderPrices.forEach(l => {
                    agreement.requests.forEach(j => {
                      if (l.RequestId === j.value) {
                        j.sum += +l.Spread / agreement.ag.course;
                      }
                    });
                  });
                }
              } else {
                if (agreement.requests[0]) agreement.requests[0].sum += +i.Spread / agreement.ag.course;
              }
              if (!agreement.comment) agreement.ag.comment = i.Comment;
              if (!agreement.startDate && i.Date) agreement.ag.startDate = i.Date.Serialized;
              if (!load) {
                context.commit('set_data', {id: id, agreements, load: false});
                callback(context.getters.regular(id));
              }
            }
          }, {root: true});
        });
      } else {
        context.commit('set_data', {
          id: id,
          legals: [
            {
              value: data.PartnerLegalEntityId,
              label: data.PartnerLegalName,
            }
          ],
          load: false
        });
        callback(context.getters.regular(id));
      }
    } else if (r.data.ResultQueryInfo.HasError) {
      context.dispatch('error', r.data.ResultQueryInfo.UserMessages, {root: true});
    }
  })).catch(e => {
    context.dispatch('error', e, {root: true});
  });
}
